export function canonicalNumberInput(value) {
  return String(value ?? '').replace(/\s/g, '').replace(',', '.');
}

export function groupedNumberInput(value) {
  const canonical = canonicalNumberInput(value);
  if (!/^-?\d*(?:\.\d*)?$/.test(canonical)) return String(value ?? '');
  const [integer, fraction] = canonical.split('.');
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return fraction === undefined ? grouped : `${grouped},${fraction}`;
}

export function groupedCaretPosition(formatted, significantCharacters) {
  if (!significantCharacters) return 0;
  let seen = 0;
  for (let index = 0; index < formatted.length; index += 1) {
    if (!/\s/.test(formatted[index])) seen += 1;
    if (seen === significantCharacters) return index + 1;
  }
  return formatted.length;
}
